import { findEventConfig } from './TriggerEvent/helpers'

export const validateTriggers = triggers => {
  const errors = []

  triggers.forEach(trigger => {
    const eventConfig = findEventConfig(trigger.type)
    const validate = eventConfig?.inputOptions?.validate

    if (!validate) return

    const message = validate(trigger[eventConfig.inputOptions.field])

    if (message) {
      errors.push({ triggerId: trigger.id, field: eventConfig.inputOptions.field, message })
    }
  })

  return errors
}
